import { render } from "./EditTrafficLabel.vue?vue&type=template&id=584c8f08&scoped=true"
import script from "./EditTrafficLabel.vue?vue&type=script&lang=js"
export * from "./EditTrafficLabel.vue?vue&type=script&lang=js"

import "./EditTrafficLabel.vue?vue&type=style&index=0&id=584c8f08&scoped=true&lang=less"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584c8f08"]])

export default __exports__